import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';
import {Authorize} from './auth/common/authorize-map';
import {AllocatorDashboardGuard} from './auth/guards/allocator-dashboard.guard';

const routes: Routes = [
    {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(module => module.DashboardModule),
        canActivate: [MsalGuard, AllocatorDashboardGuard]
    },
    {
        path: 'cases',
        loadChildren: () => import('./cases/cases.module').then(module => module.CasesModule),
        canActivate: [MsalGuard],
        data: {authorize: [Authorize.NonAllocator]}
    },
    {
        path: 'agencies',
        loadChildren: () => import('./agencies/agencies.module').then(module => module.AgenciesModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'donors',
        loadChildren: () => import('./donors/donors.module').then(module => module.DonorsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'campaigns',
        loadChildren: () => import('./campaigns/campaigns.module').then(module => module.CampaignsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'donations',
        loadChildren: () => import('./donations/donations.module').then(module => module.DonationsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(module => module.ReportsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'stats',
        loadChildren: () => import('./statistics/statistics.module').then(module => module.StatisticsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(module => module.UsersModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'adoptions',
        loadChildren: () => import('./adoptions/adoptions.module').then(module => module.AdoptionsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'allocators',
        loadChildren: () => import('./allocators/allocators.module').then(module => module.AllocatorsModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(module => module.AuthModule)
    }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            relativeLinkResolution: 'legacy',
            initialNavigation: !isIframe ? 'enabled' : 'disabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
